import React from 'react';

import { type AccessPackagePillsProps } from '../types';

// Custom SVG Icons matching legacy design
const PremiumIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.24 2.63989H5.76C5.47228 2.64779 5.19046 2.72329 4.93732 2.86028C4.68419 2.99728 4.46684 3.19192 4.30286 3.42846L1.18286 7.74846C0.951184 8.07585 0.835484 8.47123 0.854118 8.87186C0.872752 9.27249 1.02465 9.65543 1.28572 9.95989L10.6457 20.7428C10.806 20.9492 11.0113 21.1163 11.246 21.2313C11.4807 21.3462 11.7386 21.406 12 21.406C12.2614 21.406 12.5193 21.3462 12.754 21.2313C12.9887 21.1163 13.194 20.9492 13.3543 20.7428L22.7143 9.95989C22.9753 9.65543 23.1272 9.27249 23.1459 8.87186C23.1645 8.47123 23.0488 8.07585 22.8171 7.74846L19.6971 3.42846C19.5332 3.19192 19.3158 2.99728 19.0627 2.86028C18.8095 2.72329 18.5277 2.64779 18.24 2.63989V2.63989Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1086 2.6228L6.92572 9.1028L12 21.3599"
      fill="transparent"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9429 2.6228L17.1086 9.1028L12 21.3599"
      fill="transparent"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.891434 9.10278H23.1086"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MinusCircleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H5.99998C5.4477 11 4.99998 11.4477 4.99998 12C4.99998 12.5523 5.4477 13 5.99998 13H18Z"
      fill="currentColor"
    />
  </svg>
);

const CheckCircleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.99282 15.0762L7.22899 12.3123C6.76036 11.8437 6.00056 11.8437 5.53193 12.3123C5.0633 12.781 5.0633 13.5408 5.53193 14.0094L9.22955 17.707C9.24887 17.7268 9.269 17.7461 9.28992 17.7648C9.39426 17.8584 9.51103 17.9305 9.63454 17.9812C9.96592 18.117 10.3458 18.0984 10.6638 17.9252C10.7812 17.8614 10.8896 17.777 10.9832 17.6726C11.0019 17.6518 11.0197 17.6305 11.0367 17.6088L18.5551 8.25058C18.9702 7.73392 18.8878 6.9786 18.3711 6.56352C17.8545 6.14844 17.0992 6.23078 16.6841 6.74744L9.99282 15.0762Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22.2C17.6333 22.2 22.2 17.6333 22.2 12C22.2 6.3667 17.6333 1.8 12 1.8C6.3667 1.8 1.8 6.3667 1.8 12C1.8 17.6333 6.3667 22.2 12 22.2Z"
      fill="currentColor"
    />
  </svg>
);

const ClockIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_943_16586)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.09715C6.50357 2.09715 2.04783 6.55289 2.04783 12.0493C2.04783 17.5457 6.50357 22.0015 12 22.0015C17.4964 22.0015 21.9522 17.5457 21.9522 12.0493C21.9522 6.55289 17.4964 2.09715 12 2.09715ZM0 12.0493C0 5.4219 5.37258 0.0493164 12 0.0493164C18.6274 0.0493164 24 5.4219 24 12.0493C24 18.6767 18.6274 24.0493 12 24.0493C5.37258 24.0493 0 18.6767 0 12.0493Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.80374C12.5655 6.80374 13.0239 7.26216 13.0239 7.82765V11.6701L17.0661 16.3808C17.4344 16.8099 17.385 17.4564 16.9559 17.8246C16.5267 18.1929 15.8803 18.1435 15.512 17.7144L11.2229 12.716C11.0636 12.5304 10.976 12.2938 10.976 12.0492V7.82765C10.976 7.26216 11.4345 6.80374 12 6.80374Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_943_16586">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MarketIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_695_274)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.36755 -0.0548096C3.05481 -0.0548096 2.77215 0.131564 2.64895 0.419015L0.063225 6.45192C0.0152852 6.56377 -0.00514786 6.68331 0.00109415 6.80122C4.4542e-05 6.81778 -0.000488281 6.83449 -0.000488281 6.85131V8.57132C-0.000488281 9.69059 0.444175 10.764 1.23566 11.5554C1.40243 11.7222 1.58171 11.8735 1.77131 12.0086L1.7713 12.0113V22.0733C1.7713 22.52 1.90618 22.9771 2.18501 23.3395C2.46731 23.7065 2.90059 23.9715 3.41151 23.9715H20.6129C21.1238 23.9715 21.5571 23.7065 21.8394 23.3395C22.1182 22.9771 22.2531 22.52 22.2531 22.0733V12.0113C22.2531 11.9981 22.2527 11.985 22.2521 11.972C22.423 11.8463 22.5852 11.7073 22.7371 11.5554C23.5286 10.764 23.9732 9.69059 23.9732 8.57132V6.85131C23.9732 6.836 23.9728 6.82079 23.9719 6.80569C23.9789 6.68634 23.9586 6.56519 23.9101 6.45192L21.3243 0.419015C21.2011 0.131564 20.9185 -0.0548096 20.6057 -0.0548096H3.36755ZM22.413 7.54173H16.6627V8.57132C16.6627 9.27674 16.9429 9.95328 17.4418 10.4521C17.9407 10.9509 18.6173 11.2312 19.3228 11.2312H19.7528C20.4584 11.2312 21.135 10.9509 21.6338 10.4521C22.1327 9.95328 22.413 9.27674 22.413 8.57132V7.54173ZM15.1022 7.54173H8.92198V8.57132L8.92194 8.58759C8.92622 9.28714 9.20598 9.95711 9.701 10.4521C10.1999 10.9509 10.8765 11.2312 11.582 11.2312H12.4421C13.1476 11.2312 13.8242 10.9509 14.3231 10.4521C14.822 9.95328 15.1022 9.27674 15.1022 8.57132V7.54173ZM7.3616 7.54173H1.5598V8.57132C1.5598 9.27674 1.84005 9.95328 2.33891 10.4521C2.83778 10.9509 3.5144 11.2312 4.21992 11.2312H4.70156C5.40709 11.2312 6.08371 10.9509 6.58257 10.4521C7.07762 9.95709 7.35738 9.28707 7.36163 8.58749L7.3616 8.57132V7.54173ZM1.96751 5.9781L3.88306 1.50882H20.0902L22.0058 5.9781H1.96751ZM15.4263 11.5554C15.5943 11.3875 15.7467 11.2068 15.8824 11.0157C16.0182 11.2068 16.1706 11.3875 16.3385 11.5554C17.13 12.3469 18.2035 12.7915 19.3228 12.7915H19.7528C20.0717 12.7915 20.3868 12.7554 20.6928 12.6855V22.0733C20.6928 22.2197 20.6464 22.3313 20.6027 22.3882C20.5944 22.3989 20.5874 22.4063 20.5821 22.4112H3.44222C3.43697 22.4063 3.42995 22.3989 3.4217 22.3882C3.37794 22.3313 3.33159 22.2197 3.33159 22.0733V12.6969C3.62133 12.7593 3.91897 12.7915 4.21992 12.7915H4.70156C5.82087 12.7915 6.89434 12.3469 7.68582 11.5554C7.85373 11.3875 8.00603 11.207 8.14179 11.0159C8.27755 11.207 8.42984 11.3875 8.59775 11.5554C9.38924 12.3469 10.4627 12.7915 11.582 12.7915H12.4421C13.5614 12.7915 14.6349 12.3469 15.4263 11.5554Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_695_274">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IntegrationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V4.5H11.25V0.75C11.25 0.335786 11.5858 0 12 0C12.4142 0 12.75 0.335786 12.75 0.75V4.5H13.5C14.0967 4.5 14.669 4.73705 15.091 5.15901C15.5129 5.58097 15.75 6.15326 15.75 6.75V9.75C15.75 11.5402 15.0388 13.2571 13.773 14.523C12.6852 15.6108 11.2643 16.289 9.75 16.4582V18.75C9.75 19.3467 9.98705 19.919 10.409 20.341C10.831 20.7629 11.4033 21 12 21C12.5967 21 13.169 20.7629 13.591 20.341C14.0129 19.919 14.25 19.3467 14.25 18.75C14.25 17.7554 14.6451 16.8016 15.3483 16.0983C16.0516 15.3951 17.0054 15 18 15C18.9946 15 19.9484 15.3951 20.6516 16.0983C21.3549 16.8016 21.75 17.7554 21.75 18.75V23.25C21.75 23.6642 21.4142 24 21 24C20.5858 24 20.25 23.6642 20.25 23.25V18.75C20.25 18.1533 20.0129 17.581 19.591 17.159C19.169 16.7371 18.5967 16.5 18 16.5C17.4033 16.5 16.831 16.7371 16.409 17.159C15.9871 17.581 15.75 18.1533 15.75 18.75C15.75 19.7446 15.3549 20.6984 14.6517 21.4017C13.9484 22.1049 12.9946 22.5 12 22.5C11.0054 22.5 10.0516 22.1049 9.34835 21.4017C8.64509 20.6984 8.25 19.7446 8.25 18.75V16.4582C6.73574 16.289 5.31485 15.6108 4.22703 14.523C2.96116 13.2571 2.25 11.5402 2.25 9.75V6.75C2.25 6.15326 2.48705 5.58097 2.90901 5.15901C3.33097 4.73705 3.90326 4.5 4.5 4.5H5.25V0.75C5.25 0.335786 5.58579 0 6 0ZM9 15C10.3924 15 11.7277 14.4469 12.7123 13.4623C13.6969 12.4777 14.25 11.1424 14.25 9.75V6.75C14.25 6.55109 14.171 6.36032 14.0303 6.21967C13.8897 6.07902 13.6989 6 13.5 6H12H6H4.5C4.30109 6 4.11032 6.07902 3.96967 6.21967C3.82902 6.36032 3.75 6.55109 3.75 6.75V9.75C3.75 11.1424 4.30312 12.4777 5.28769 13.4623C6.27226 14.4469 7.60761 15 9 15ZM6.75 8.25C6.75 7.83579 7.08579 7.5 7.5 7.5H10.5C10.9142 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 10.9142 9 10.5 9H7.5C7.08579 9 6.75 8.66421 6.75 8.25Z"
      fill="currentColor"
    />
  </svg>
);

// Access package configuration matching legacy design
const accessPackageConfig: Record<
  string,
  {
    label: string;
    bgColor: string;
    textColor: string;
    icon: React.ComponentType<{ className?: string }>;
  }
> = {
  free: {
    label: 'Free',
    bgColor: '#FAF7F5', // cream (neutralBgMedium)
    textColor: '#666666', // gray600 (neutralTextMedium)
    icon: MinusCircleIcon,
  },
  verified: {
    label: 'Verified',
    bgColor: '#D1EDD8', // mint (brandSecondary12)
    textColor: '#034B46', // spinach (brandSecondary10)
    icon: CheckCircleIcon,
  },
  trial: {
    label: 'Trial',
    bgColor: '#FFEFBD', // coconut (brandSecondary3)
    textColor: '#AC2819', // gojiBerry (brandSecondary7)
    icon: ClockIcon,
  },
  premium: {
    label: 'Premium',
    bgColor: '#C0D5FF', // chocoLightBlue (brandPrimary4)
    textColor: '#1A0D78', // chocoMidBlue (brandPrimary2)
    icon: PremiumIcon,
  },
  leadGen: {
    label: 'Lead Gen',
    bgColor: '#E0EAFF', // chocoVeryLightBlue (brandPrimary5)
    textColor: '#3D6BFF', // chocoBlue (brandPrimary1)
    icon: MarketIcon,
  },
};

export const AccessPackagePills: React.FC<AccessPackagePillsProps> = ({
  accessPackage,
  isIntegrated,
}) => {
  const pkg = accessPackage || 'free';
  const config = accessPackageConfig[pkg] || accessPackageConfig.free;
  const IconComponent = config.icon;

  return (
    <div className="flex flex-col gap-1">
      {/* Access Package Badge */}
      <div
        className="inline-flex items-center gap-1.5 rounded-md px-1.5 py-0.5 w-fit"
        style={{
          backgroundColor: config.bgColor,
          color: config.textColor,
        }}
        title={pkg}
      >
        <IconComponent className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="text-xs font-medium leading-none">{config.label}</span>
      </div>

      {/* Integrated Badge */}
      {isIntegrated && (
        <div
          className="inline-flex items-center gap-1.5 rounded-md px-1.5 py-0.5 w-fit"
          style={{
            backgroundColor: '#C0D5FF', // chocoLightBlue (baseTextWeakActive)
            color: '#1A0D78', // chocoMidBlue (baseTextMedium)
          }}
          title="Integrated"
        >
          <IntegrationIcon className="h-3.5 w-3.5 flex-shrink-0" />
          <span className="text-xs font-medium leading-none">Integrated</span>
        </div>
      )}
    </div>
  );
};
